import AboutSection from "../../Components/HomeSections/AboutSection";
import AttorneySection from "../../Components/HomeSections/AttorneySection";
import HeroSection from "../../Components/HomeSections/HeroSection";
import PracticeAreas from "../../Components/HomeSections/Practices";
import TestimonialSlider from "../../Components/HomeSections/Testimonials";
import WhyChooseUs from "../../Components/HomeSections/WhyChooseUs";
import ContactForm from "../../Components/HomeSections/ContactForm";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import ServicesList from "../../Components/Services/ServicesList";
// import { Helmet } from "react-helmet";

const HomePage =()=>{
    return(
        <>
         {/* <Helmet>
        <title>Nyaysakti Home - Trusted Legal Services</title>
        <meta
          name="description"
          content="Nyaysakti Chambers: Expert legal solutions, trusted lawyers, and decades of excellence in serving clients. Explore our services and success stories."
        />
        <meta
          name="keywords"
          content="Nyaysakti, Law Firm, Lawyers, Legal Services, Legal Expertise, Justice"
        />
        <noscript>
          Please enable JavaScript to view this website properly.
        </noscript>
      </Helmet> */}

        <Header/>
        <HeroSection/>
        <AboutSection/>
        <PracticeAreas/>
        <WhyChooseUs/>
        <AttorneySection/>
        <TestimonialSlider/>
        <ContactForm/>
        <ServicesList/>
        <Footer/>
        </>
    )
}

export default HomePage;